import type { Ref } from 'vue';

import { defineStore, ref } from '#imports';

import type { Alert } from './alerts.types';

export const useAlertsStore = defineStore(
    'alerts',
    () => {
        let id = 0;
        const timerDefault = 2000;
        const alerts: Ref<Alert[]> = ref([]);

        function getNextId() {
            return ++id;
        }

        function add({ timer = timerDefault, ...config }: Omit<Alert, 'id'>) {
            const alert: Alert = {
                id: getNextId(),
                timer,
                ...config
            };

            alerts.value.push(alert);

            if (!config.critical) {
                setTimeout(
                    () => remove(alert.id),
                    timer
                );
            }
        }

        function remove(id: Alert['id']) {
            alerts.value = alerts.value.filter(alert => alert.id !== id);
        }

        return {
            alerts,
            timerDefault,
            add,
            remove
        } as const;
    }
);
